module.exports = __webpack_public_path__ + "static/media/13.102427c1.jpg";